import React from "react";
import "@/App.css";

// Section imports - Premium Editorial Design
import { Navigation } from "./sections/Navigation";
import { Hero } from "./sections/Hero";
import { TrustStrip } from "./sections/TrustStrip";
import { ProblemSection } from "./sections/ProblemSection";
import { CharlesIntro } from "./sections/CharlesIntro";
import { MechanismSection } from "./sections/MechanismSection";
import { BenefitsSection } from "./sections/BenefitsSection";
import { OfferBreakdown } from "./sections/OfferBreakdown";
import { FAQSection } from "./sections/FAQSection";
import { GuaranteeSection } from "./sections/GuaranteeSection";
import { FinalCTA } from "./sections/FinalCTA";
import { Footer } from "./sections/Footer";

function App() {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      {/* Navigation */}
      <Navigation />
      
      {/* Hero - Two Column with Wistia Video */}
      <Hero />
      
      {/* Trust Indicators - Subtle */}
      <TrustStrip />
      
      {/* The Challenge */}
      <ProblemSection />
      
      {/* About Charles Payne */}
      <CharlesIntro />
      
      {/* The Framework */}
      <MechanismSection />
      
      {/* What Changes */}
      <BenefitsSection />
      
      {/* What's Included - Value Stack */}
      <OfferBreakdown />
      
      {/* FAQ */}
      <FAQSection />
      
      {/* Guarantee */}
      <GuaranteeSection />
      
      {/* Final CTA */}
      <FinalCTA />
      
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
